import { render, staticRenderFns } from "./ChangeLabelModal.vue?vue&type=template&id=385497ab"
import script from "./ChangeLabelModal.vue?vue&type=script&lang=ts"
export * from "./ChangeLabelModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports